class EntryBtn {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $(window).on('scroll', function() {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const $footer = $('.c-footer-top');
      let footerOffsetTop = Infinity;
      if ($footer.length > 0 && typeof $footer.offset() !== 'undefined') {
        footerOffsetTop = $footer.offset().top;
      }

      if (scrollTop > 100) {
        $('.js-entry-trigger').addClass('is-active');
      } else {
        $('.js-entry-trigger').removeClass('is-active');
      }
    
      if (scrollTop + windowHeight >= footerOffsetTop) {
        $('.js-entry-trigger').removeClass('is-active');
      }
    });

    $('.js-entry-trigger').click(function () {
      $('html').addClass('is-entry-open');
      scrollBan();
    });

    $('.c-modal-entry__close,.c-modal-overlay').click(function (e) {
      e.preventDefault();
      $('html').removeClass('is-entry-open');
      scrollBan();
    });
  }
}